<template>
  <MainLayout page-name="user-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">新規追加</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <UserId v-model="simpleSearchFormModel.user_id" :searchCond="true" :autocomplete-list="userIdSet" prop="user_id"/>
        <UserName v-model="simpleSearchFormModel.user_name" :searchCond="true" :autocomplete-list="userNameSet" />
        <!-- <CustomerCode v-model="simpleSearchFormModel.customer_code" :searchCond="true" :initialize="true" /> -->
        <CustomerCode v-model="simpleSearchFormModel.customer_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true" label="請求先" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :default-sort="{ prop: 'user_id', order: 'ascending' }"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <UserIdColumn :sortable="true" />
        <UserNameColumn :sortable="true" />
        <CustomerCodeColumn :sortable="true" />
        <PhoneNumberColumn :sortable="true" />
        <EmailColumn :sortable="true" />
        <RoleIdColumn :sortable="true" />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" /> -->
        <UserIdColumn />
        <UserNameColumn />
        <CustomerCodeColumn />
        <PhoneNumberColumn />
        <EmailColumn />
        <RoleIdColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" />
      </template>
    </Table>
    <UserMasterRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-user-id-set="userIdSet"
      :autocomplete-user-name-set="userNameSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <UserMasterDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-user-id-set="userIdSet"
      :autocomplete-user-name-set="userNameSet"
      :autocomplete-customer-code-set="customerCodeSet"
      @search="detailSearch"
    />
    <UserMasterEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-user-id-set="userIdSet"
      :autocomplete-user-name-set="userNameSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
      programName="UserMasterPage"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import UserId from '@/components/molecules/form/autocomplete/UserId.vue'
import UserName from '@/components/molecules/form/autocomplete/UserName.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import UserIdColumn from '@/components/molecules/table/UserIdColumn.vue'
import UserNameColumn from '@/components/molecules/table/UserNameColumn.vue'
import CustomerCodeColumn from '@/components/molecules/table/CustomerCodeColumn.vue'
import PhoneNumberColumn from '@/components/molecules/table/PhoneNumberColumn.vue'
import EmailColumn from '@/components/molecules/table/EmailColumn.vue'
import RoleIdColumn from '@/components/molecules/table/RoleIdColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import UserMasterRegisterDialog from '@/components/pages/master/cognitoUserMaster/UserMasterRegisterDialog.vue'
import UserMasterDetailSearchDialog from '@/components/pages/master/cognitoUserMaster/UserMasterDetailSearchDialog.vue'
import UserMasterEditDialog from '@/components/pages/master/cognitoUserMaster/UserMasterEditDialog.vue'
import UserAutocompleteLoader from '@/mixins/UserAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    UserId,
    UserName,
    CustomerCode,
    SimpleSearch,
    Table,
    UserIdColumn,
    UserNameColumn,
    CustomerCodeColumn,
    PhoneNumberColumn,
    EmailColumn,
    RoleIdColumn,
    MenuColumn,
    UserMasterRegisterDialog,
    UserMasterDetailSearchDialog,
    UserMasterEditDialog
  },
  mixins: [
    UserAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  data () {
    return {
      title: '担当者マスタ',
      tableData: [],
      simpleSearchFormModel: {
        user_id: '',
        user_name: '',
        customer_code: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
      // registrationSymbolAutocompleteList: []
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('userSearchCond')
    this.loadUser()
    this.loadCustomer()
  },
  methods: {
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('userSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('userSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('userSearchCond'))
      searchCond.syori = 'user_maseter_page'
      this.$axios
        .get('/search-user', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch () {
      this.search()
      this.margeUserIdSet(this.tableData.map((x) => x.user_id))
      this.margeUserNameSet(this.tableData.map((x) => x.user_name))
      this.refreshUserAutocompleteList()
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.currentRow.change_password = false
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.currentRow.change_password = false
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      this.currentRow = row
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/user', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
</style>
<style lang="scss">
  .user-master .el-table {
    th,
    td {
      &.customer-code {
        width: 9em !important;
      }
    }
  }
</style>
